module.exports = __webpack_public_path__ + "freezeIcon-aaa1c93c4d69a53355adbc42f3c49ca7.png";